import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbDateParserFormatter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../Component/Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../Util/DateFormat/date-format.service';
import { ComboService } from '../../Model/Combo/combo.service';
import { CommonService } from '../../Model/Common/common.service';
import { EmployeeConfirmationService } from '../../Model/EmployeeConfirmation/employee-confirmation.service';
import { UtilityService } from '../../Model/utility/utility.service';
import { SessionService } from '../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../Util/Toast/toast.service';
import { TooltipService } from '../../Util/Tooltip/tooltip.service';
import { ConfirmationComponent } from '../../Component/Confirmation/confirmation/confirmation.component';
import { AlertSuccessComponent } from '../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../Component/Alert/alert-warning/alert-warning.component';
import moment from 'moment';

@Component({
  selector: 'app-emp-confirmation-bulk',
  standalone: true,
  imports: [CommonModule, FormsModule, NgbDatepickerModule, DataTablesModule, RouterModule, LoaderComponent, NgSelectModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './emp-confirmation-bulk.component.html',
  styleUrl: './emp-confirmation-bulk.component.scss'
})
export class EmpConfirmationBulkComponent {
  isDisabled: boolean = false;
  user = [] as any;
  Templates = []
  Branchs = [];
  Clients = [];
  Sites = [];
  DateTypes = [{ DateTypeValue: 'joining', DateType: 'Joining' }, { DateTypeValue: 'probation', DateType: 'Probation' }];
  Filter = {
    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    ApprovalStatus: 'Not-Initiated',
    IsDate: false,
    SelectType: 'Admin',
    Ids: '',
    EmpType: 'front',
    TemplateID: null,
    DateSelectionType: 'probation',
    BranchId: null,
    ClientId: null,
    SiteId: null,
  }

  Checks = {
    SelectType: 'i',
    EmpMasterId: null,
    ESS_QuestionnareTemplateMainId: null,
    DefaultAnswer: null,
    DefaultScore: null as any,
    IsConfirmationDate: false,
    ConfirmationDateObj: null,
    ConfirmationDate: null as any,
  }

  MainDatas = [];
  TableDatas = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    private dateFormat: CustomDateParserFormatter,
    protected common: CommonService,
    private session: SessionService,
    private toast: ToastService,
    private tooltip: TooltipService,
    private employeeconfirmation: EmployeeConfirmationService,
    private modalService: NgbModal,
    private combo: ComboService,
    private utility: UtilityService,
  ) {
    this.common.getPageRights();
    // this.user = this.session.GetUserDetails();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate', null, null);
    this.ESS_QuestionnareTemplate();
    this.ComboLoad('Branch')
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ConfirmationLoad();
    }
    else {
      form.submitted = true;
    }
  }

  ConfirmationLoad() {
    if (!this.Filter.IsDate || (this.Filter.IsDate && (moment(this.dateFormat.format(this.Filter.ToDateObj), 'DD MMM YYYY').isSameOrAfter(moment(this.dateFormat.format(this.Filter.FromDateObj), 'DD MMM YYYY'))))) {
      this.TableDatas = [];
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
      this.ESS_EmployeeConfirmationDetails();
    } else {
      this.toast.show({ message: this.tooltip.Message.FromDateToDateMessgae, type: toastTypeEnum.danger });
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Site') {
      this.Filter.SiteId = null;
      this.Sites = [];
    } else if (Combotype == 'Client') {
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
      this.Clients = [];
      this.Sites = [];
    }

    this.combo.ComboLoad({
      'Combotype': Combotype, 'BranchId': this.Filter.BranchId, 'ClientId': this.Filter.ClientId, 'SiteId': this.Filter.SiteId, 'DesignationId': null, 'EmpType': this.user.UserType, 'EmpMasterID': this.user.UserId
    }).subscribe({
      next: (response) => {
        if (response.ComboLoad) {
          if (Combotype == 'Branch') {
            this.Branchs = response.ComboLoad;
          } else if (Combotype == 'Client') {
            this.Clients = response.ComboLoad;
          } else if (Combotype == 'Site') {
            this.Sites = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_QuestionnareTemplate() {
    this.isDisabled = true;
    this.Templates = []
    this.employeeconfirmation.ESS_QuestionnareTemplate({ WEBESSModuleMasterId: 0, SelectType: '1', ESS_QuestionnareTemplateMainId: 0 }).subscribe({
      next: (response) => {
        if (response.Table) {
          this.Templates = response.Table;
          if (this.Templates.filter((e: any) => e.DefaultTemplate).length > 0) {
            this.Filter.TemplateID = this.Templates.filter((e: any) => e.DefaultTemplate)[0]['ESS_QuestionnareTemplateMainId'];
          }

        }
        this.isDisabled = false;
      },
      complete: () => { this.isDisabled = false; },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string, BirthDate: any, JoiningDate: any) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType, 'BirthDate': BirthDate, 'JoiningDate': JoiningDate, }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.ToDateObj.day = new Date(this.Filter.ToDateObj.year, this.Filter.ToDateObj.month, 0).getDate();
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
        this.toast.show({ message: error, type: toastTypeEnum.danger });
        return false;
      },
    });
  }

  StatusReplace(status: String) {
    return this.common.ToLowerCase(status) == 'rejected' ? 'Extended' : status;
  }

  Check(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.TableDatas.map((e: any) => (e.ESS_QuestionnareTemplateMainId == null || e.ESS_QuestionnareTemplateMainId == '' || e.ESS_QuestionnareTemplateMainId == 0) ? e.IsCheck = event.target.checked : e.IsCheck = false);
    } else {
      this.TableDatas[i].IsCheck = event.target.checked;
    }
  }

  FilterEmpType(type: string) {
    this.Filter.EmpType = type;
    this.isDisabled = true;
    this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
    this.isDisabled = false;
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  ESS_EmployeeConfirmationDetails() {
    this.isDisabled = true;
    if (!this.Filter.IsDate) {
      this.Filter.FromDate = null;
      this.Filter.ToDate = null;
    } else {
      this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
      this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    }

    this.employeeconfirmation.ESS_EmployeeConfirmationDetails(this.Filter).subscribe({
      next: (response) => {
        this.MainDatas = response.Table;
        // this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
        this.TableDatas = this.Filter.EmpType === 'All' ? response.Table : Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
        // this.MainDatas = response.Table;
        // this.TableDatas = Object.values(this.MainDatas.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_EmployeeConfirmation_BulkInsert(form: any) {
    if (form.valid) {
      if (this.TableDatas.filter((e: any) => e.IsCheck).length > 0) {
        if (this.Checks.DefaultScore <= 5 && this.Checks.DefaultScore > 0) {
          const modalRef = this.modalService.open(ConfirmationComponent);
          modalRef.componentInstance.Message = 'Are you sure you want to confirm?';
          modalRef.result.then((result) => {
            if (this.common.PageRight.IsEdit || this.common.PageRight.IsAdd) {
              if (result) {
                this.isDisabled = true;
                this.Checks.SelectType = 'i';
                if (this.Checks.IsConfirmationDate) {
                  this.Checks.ConfirmationDate = this.dateFormat.format(this.Checks.ConfirmationDateObj);
                } else {
                  this.Checks.ConfirmationDate = null;
                }
                this.Checks.EmpMasterId = this.TableDatas.filter((e: any) => e.IsCheck).map((e: any) => e.EmpMasterId).toString();
                this.Checks.ESS_QuestionnareTemplateMainId = this.Filter.TemplateID;

                this.employeeconfirmation.ESS_EmployeeConfirmation_BulkInsert(this.Checks).subscribe({
                  next: (response) => {
                    if (response.Error_Code == '497') {
                      const modalRef = this.modalService.open(AlertSuccessComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = response.Error_Message;
                      modalRef.result.then((result: any) => {
                        if (result) {
                          this.Checks.EmpMasterId = null;
                          this.Checks.ESS_QuestionnareTemplateMainId = null;
                          this.Checks.DefaultAnswer = null;
                          this.Checks.DefaultScore = null;
                          this.Checks.IsConfirmationDate = false;
                          this.Checks.ConfirmationDateObj = null;
                          this.Checks.ConfirmationDate = null;
                          this.Filter.TemplateID = null;

                          this.ConfirmationLoad();
                        }
                      });
                    }
                    else {
                      const modalRef = this.modalService.open(AlertWarningComponent, {
                        size: 'md',
                        backdrop: 'static',
                        centered: true,
                        windowClass: 'confirmation-modal'
                      });
                      modalRef.componentInstance.Message = response.Error_Message;
                      modalRef.result.then((result: any) => { });
                    }
                    this.isDisabled = false;
                  },
                  complete: () => { this.isDisabled = false; },
                  error: (error) => {
                    this.isDisabled = false;
                  },
                });
              }
            }
            else {
              this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
            }
          });
        } else {
          this.toast.show({ message: 'Please enter rating between 1 to 5 !', type: toastTypeEnum.warning });
        }
      } else {
        this.toast.show({ message: 'Please select atlease on record', type: toastTypeEnum.warning });
      }
    }
    else {
      form.submitted = true;
    }
  }

  ClearData() {
    this.TableDatas = Object.values([]);
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
}
